
<p-dialog
  [(visible)]="isSurveysOpen"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '60%' }"
  styleClass="custom-survey-dialog">

  <p-header>
    <i class="pi pi-list-check mr-2"></i>
    Açık Anketler
  </p-header>

  <div class="p-dialog-content">
    <div class="survey-list" *ngIf="surveysOptions.length > 0; else elseBlock">
      <div *ngFor="let survey of surveysOptions" class="survey-item-container">
        <div class="survey-card">
          <div class="survey-header">
            <div class="survey-info">
              <h4 class="survey-title">{{ survey.name }}</h4>
              <span class="survey-status"
                [ngClass]="survey.isAnswered ? 'status-completed' : (survey.isSmsTrue && !survey.userAnswered ? 'status-pending' : '')">
                <i class="pi"
                  [ngClass]="survey.isAnswered ? 'pi-check-circle' : (survey.isSmsTrue && !survey.userAnswered ? 'pi-clock' : '')">
                </i>
                {{ survey.isAnswered ? 'Tamamlandı' : (survey.isSmsTrue && !survey.userAnswered ? 'Bekliyor' : '') }}

                <i *ngIf="survey?.phoneAnswered" class="pi pi-phone" title="SMS ile cevap verilmiş"></i>
                <i *ngIf="survey?.userAnswered" class="pi pi-user" title="Kullanıcı cevabı"></i>
              </span>
            </div>
          </div>
          <div class="survey-actions">
            <button *ngIf="survey.isAnswered" pButton label="Cevapları Görüntüle" icon="pi pi-eye"
              class="p-button-rounded p-button-success survey-action-btn" (click)="showSurveyAnswers(survey)">
            </button>
            <ng-container>
              <button pButton *ngIf="!survey.isAnswered" label="Anketi Cevapla" icon="pi pi-pencil"
                class="p-button-rounded p-button-primary survey-action-btn" (click)="selectSurvey(survey)">
              </button>
              <button pButton label="SMS Gönder" *ngIf="!survey.isAnswered" icon="pi pi-mobile"
                class="p-button-rounded p-button-secondary survey-action-btn" (click)="sendManuelSMS(survey)">
              </button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <ng-template #elseBlock>
      <div class="empty-state">
        <i class="pi pi-info-circle"></i>
        <h3>Anket bulunamadı</h3>
        <p>Bu vaka tipi için henüz anket tanımlanmamış.</p>
      </div>
    </ng-template>
  </div>
</p-dialog>

<p-dialog
  [header]="'SMS Gönder'"
  [(visible)]="isSurveysPhone"
  [modal]="true"
  [closable]="true"
  (onHide)="clearSurveyDialog()"
  [style]="{ width: '45rem', 'max-height': '75vh', 'overflow-y': 'auto' }"
  styleClass="custom-survey-sms-dialog">

  <div class="modal-body">
    <div class="form-group" *ngIf="selectedSmsTemplate">
      <label for="">Telefon No</label>
      <div class="phone-chips-container" *ngIf="patientPhones && patientPhones.length > 0">
        <div
          *ngFor="let phone of patientPhones"
          class="phone-chip"
          [class.selected]="selectedPhoneForSurvey === phone"
          (click)="selectPhoneForSurvey(phone)" role="button"  tabindex="-1">
          {{ phone }}
        </div>
      </div>
      <div class="selected-phone-container" >
        <input
          type="text"
          class="selected-phone-input"
          [value]="selectedPhoneForSurvey"
          readonly
          placeholder="Telefon numarası seçin"
        />
        <button
          *ngIf="selectedPhoneForSurvey"
          type="button"
          class="clear-phone-btn"
          (click)="clearPhoneSelection()">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>

    <div class="form-group" *ngIf="selectedSmsTemplate">
      <label for="">SMS İçeriği</label>
      <div class="sms-content-container">
        <textarea
          class="sms-content"
          [value]="getSmsContent()"
          readonly
          rows="4">
        </textarea>
      </div>
    </div>
  </div>
  <div *ngIf="!selectedSmsTemplate">
    <p>Anket Gönderimi ile ilgili bir parametre bulunamadı.</p>
  </div>
  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button
        type="button"
        class="send-button"
        [disabled]="!selectedPhoneForSurvey"
        (click)="sendSurveyToPhone(selectedPhoneForSurvey)">
        Gönder
      </button>
    </div>
  </ng-template>
</p-dialog>



<p-dialog
  [(visible)]="isSurveyDialogVisible"
  [modal]="true"
  [style]="{ width: '90vw', height: '90vh' }"
  [draggable]="false"
  [resizable]="true"
  header="Anket"
  (onHide)="closeSurveyDialog()"
>
  <iframe
    *ngIf="surveyUrl"
    [src]="surveyUrl"
    title=""
    style="width: 100%; height: calc(90vh - 100px); border: none"
  >
  </iframe>
</p-dialog>

<app-send-mail-sms #sendManuelSMSMail [type]="'sms'" false (sendAction)="handleSMSAction($event)"
    (closed)="onPopupClosed()">
</app-send-mail-sms>
